import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';

import { ValidatedTextField } from 'components';

interface IProps {
  i18nKey: string;
  working: boolean;
}

const LeaderboardTitle: FC<IProps> = ({ i18nKey, working }) => {
  const { t } = useTranslation();

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <StarIcon color="disabled" />
      </Grid>
      <Grid item xs={6}>
        <ValidatedTextField
          name="title"
          i18nKey="admin:leaderboardsPlaceholder"
          color="primary"
          TextFieldProps={{ margin: 'none', label: null }}
        />
      </Grid>
      <Grid item xs={2}>
        <Button disabled={working} size="large" type="submit" variant="contained" color="primary">
          {t(i18nKey)}
        </Button>
      </Grid>
    </Grid>
  );
};

export default LeaderboardTitle;
